export default __webpack_public_path__ + "static/media/locker.f879b619.svg";